import {useEffect, useState} from "react";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const useSse = () => {
    const [graphData, setGraphData] = useState(undefined);
    const [countersData, setCountersData] = useState(undefined);
    const [tableData, setTableData] = useState(undefined);

    useEffect(() => {
        const eventSource = new EventSource(API_DESPACHO + "/duty-information");

        eventSource.onmessage = event => {
            let parsedData = JSON.parse(event.data);

            if (!parsedData) return;
            if (parsedData.type === "graphData") setGraphData(parsedData.value);
            else if (parsedData.type === "countersData") setCountersData(parsedData.value);
            else if (parsedData.type === "tableData") setTableData(parsedData.value);
        };

        eventSource.onerror = e => {
            console.error("Erro to load duty-information:", e);
        };

        return () => eventSource.close();
    }, []);

    return { graphData, countersData, tableData };
};

export default useSse;